module.exports = __webpack_public_path__ + "static/Lamentum7-2499e976b11c6b3541b832ab7c422865.png";